<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#3EA56E" left :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-container class="px-2 px-sm-4 py-6">
      <!-- Back Button & Header -->
      <v-row align="start" class="mb-6">
        <v-col cols="12">
          <div class="d-flex align-start align-sm-center">
            <v-btn icon @click="$router.go(-1)" class="mr-2 mt-n1 mt-sm-0">
              <v-icon color="#1c1c1c">mdi-arrow-left</v-icon>
            </v-btn>
            <div class="d-flex flex-column flex-sm-row align-start align-sm-center flex-grow-1">
              <h1 class="page-title mr-sm-4">Track Order</h1>
              <v-spacer class="hidden-xs-only"></v-spacer>
              <v-chip
                v-if="order.orderID"
                color="#3EA56E"
                label
                outlined
                class="id-chip px-4 mt-2 mt-sm-0"
              >
                Order #{{ order.orderID }}
              </v-chip>
            </div>
          </div>
        </v-col>
      </v-row>

      <!-- Order Tracking Card -->
      <v-row class="mb-6">
        <v-col cols="12">
          <v-card flat class="tracking-main-card pa-6">
            <v-row align="center" class="mb-8">
              <v-col cols="12" sm="8">
                <div class="d-flex flex-column">
                  <span class="banner-label">Placed On</span>
                  <span class="banner-value">{{ formatDate(order.create_date) }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="4" class="text-sm-right">
                <v-chip color="#3EA56E" dark small label class="font-weight-bold">
                  {{ customerInfo.paymentStatus === 'PAID' ? 'PAID' : customerInfo.paymentStatus }}
                </v-chip>
              </v-col>
            </v-row>

            <!-- Stepper -->
            <div class="stepper-wrapper">
              <v-stepper :value="currentStep" elevation="0" class="custom-stepper">
                <v-stepper-header class="shadow-none">
                  <template v-for="(step, index) in steps2">
                    <v-stepper-step
                      :key="index"
                      :color="step.header === 'Cancelled' ? '#EF4444' : '#3EA56E'"
                      :complete="step.content"
                      :step="index + 1"
                    >
                      <span class="step-label">{{ step.header }}</span>
                    </v-stepper-step>
                    <v-divider v-if="index < steps2.length - 1" :key="'div-' + index"></v-divider>
                  </template>
                </v-stepper-header>
              </v-stepper>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <!-- Detailed Info -->
      <v-row>
        <!-- Product Info -->
        <v-col cols="12" md="6">
          <v-card flat class="info-card pa-6 h-full">
            <div class="d-flex align-center mb-4">
              <v-icon color="#3EA56E" class="mr-2">mdi-package-variant</v-icon>
              <h2 class="info-title">Product Information</h2>
            </div>
            <v-divider class="mb-4"></v-divider>
            <div class="info-item mb-3">
              <span class="label">Product Name</span>
              <span class="value">{{ order.productId ? order.productId.productname : 'N/A' }}</span>
            </div>
            <div class="info-row">
              <div class="info-item">
                <span class="label">Quantity</span>
                <span class="value">{{ order.quantity }}</span>
              </div>
              <v-divider vertical class="mx-4"></v-divider>
              <div class="info-item">
                <span class="label">Total Amount</span>
                <span class="value highlight">Rs. {{ order.TotalAmount }}</span>
              </div>
            </div>
          </v-card>
        </v-col>

        <!-- Customer Info -->
        <v-col cols="12" md="6">
          <v-card flat class="info-card pa-6 h-full">
            <div class="d-flex align-center mb-4">
              <v-icon color="#3EA56E" class="mr-2">mdi-account-outline</v-icon>
              <h2 class="info-title">Delivery Information</h2>
            </div>
            <v-divider class="mb-4"></v-divider>
            <div v-if="customerInfo.deliveryAddress" class="delivery-details">
              <div class="customer-name">{{ customerInfo.deliveryAddress.firstname }} {{ customerInfo.deliveryAddress.lastname }}</div>
              <div class="address-text mt-1">
                {{ customerInfo.deliveryAddress.streetAddress }}, {{ customerInfo.deliveryAddress.locality }},<br>
                {{ customerInfo.deliveryAddress.city }}, {{ customerInfo.deliveryAddress.district }},<br>
                {{ customerInfo.deliveryAddress.state }} - {{ customerInfo.deliveryAddress.pincode }}
              </div>
              <div class="contact-meta mt-3">
                <div class="d-flex align-center mb-1">
                  <v-icon size="16" color="#64748b" class="mr-2">mdi-phone-outline</v-icon>
                  <span>{{ customerInfo.deliveryAddress.delphone }}</span>
                </div>
                <div v-if="customerInfo.deliveryAddress.email" class="d-flex align-center">
                  <v-icon size="16" color="#64748b" class="mr-2">mdi-email-outline</v-icon>
                  <span>{{ customerInfo.deliveryAddress.email }}</span>
                </div>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading: false,
      customerInfo: [],
      timeout: 5000,
      msg: "",
      ServerError: false,
      showSnackBar: false,
      orders: [],
      product: [],
      header: null,
      order: {},
      cancelDialog: false,
      currentStep: 0,
      steps2: [
        {
          header: "Pending",
          content: false,
        },
        {
          header: "Order Confirmed",
          content: false,
        },
        {
          header: "Shipped",
          content: false,
        },
        {
          header: "Out For Delivery",
          content: false,
        },
        {
          header: "Delivered",
          content: false,
        },
      ],
    };
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "post",
        url: "/item/order/details",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          itemId: this.$route.query.id,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.appLoading = false;
            this.order = response.data.data;
            this.customerInfo = response.data.data.orderId;
            this.steps = response.data.data.trackItem;
            for(let i=0;i<this.steps.length;i++){
              if(i==0){
                if(this.steps[0].status=='Cancelled'){
                    this.steps2[0].header="Cancelled";
                }
                this.steps2[0].content=true;
                
              }
              else if(i==1){
                 if(this.steps[1].status=='Cancelled'){
                    this.steps2[1].header="Cancelled";
                }
               
               this.steps2[1].content=true;
              
              }
              else if(i==2){
                 if(this.steps[2].status=='Cancelled'){
                    this.steps2[2].header="Cancelled";
                }
               
                this.steps2[2].content=true;
               
              }
              else if(i==3){
                if(this.steps[3].status=='Cancelled'){
                    this.steps2[3].header="Cancelled";
                }
                this.steps2[3].content=true;
              }
              else{
                if(this.steps[4].status=='Cancelled'){
                    this.steps2[4].header="Cancelled";
                }
                this.steps2[4].content=true;
              }
            }
            // this.orders = response.data.data.details;
          } else {
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    formatDate(item) {
      if (!item) return "";
      var defDate = new Date(item);
      defDate = defDate.toString().slice(0, 15);
      var today = new Date();
      today = today.toString().slice(0, 15);

      var yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      yesterday = yesterday.toString().slice(0, 15);

      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      dt = dt.toString();
      var strTime = dt.slice(0, 4) + day + " " + dt.slice(4, 7) + " " + year;

      if (today == defDate) {
        return "Today";
      } else if (yesterday == defDate) {
        return "Yesterday";
      } else {
        return strTime;
      }
    },
  },
};
</script>

<style scoped>
.page-title {
  font-family: "poppinssemibold", sans-serif;
  font-size: 24px;
  color: #1e293b;
  margin: 0;
}

.id-chip {
  font-family: "poppinsmedium", sans-serif;
  letter-spacing: 0.5px;
}

.tracking-main-card {
  border: 1px solid #e2e8f0;
  border-radius: 20px !important;
  background: #ffffff;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.04) !important;
}

.banner-label {
  font-family: "poppinsmedium", sans-serif;
  font-size: 13px;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.banner-value {
  font-family: "poppinssemibold", sans-serif;
  font-size: 18px;
  color: #1e293b;
}

.custom-stepper {
  background: transparent !important;
}

.custom-stepper ::v-deep .v-stepper__header {
  box-shadow: none !important;
  border-bottom: none !important;
}

.step-label {
  font-family: "poppinsmedium", sans-serif;
  font-size: 12px;
  color: #475569;
}

.info-card {
  border: 1px solid #f1f5f9;
  border-radius: 16px !important;
  background: #f8fafc;
}

.info-title {
  font-family: "poppinssemibold", sans-serif;
  font-size: 15px;
  color: #1e293b;
  margin: 0;
}

.info-item {
  display: flex;
  flex-direction: column;
}

.info-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.label {
  font-family: "poppinsmedium", sans-serif;
  font-size: 12px;
  color: #94a3b8;
  text-transform: uppercase;
  margin-bottom: 2px;
}

.value {
  font-family: "poppinssemibold", sans-serif;
  font-size: 15px;
  color: #1e293b;
}

.highlight {
  color: #3ea56e;
  font-size: 17px;
}

.customer-name {
  font-family: "poppinssemibold", sans-serif;
  font-size: 16px;
  color: #1e293b;
}

.address-text {
  font-family: "poppinsregular", sans-serif;
  font-size: 14px;
  color: #64748b;
  line-height: 1.5;
}

.contact-meta {
  font-family: "poppinsmedium", sans-serif;
  font-size: 13px;
  color: #475569;
}

.h-full {
  height: 100%;
}

@media (max-width: 600px) {
  .page-title {
    font-size: 20px;
  }
  .custom-stepper ::v-deep .v-stepper__header {
    flex-direction: column;
    height: auto;
    align-items: flex-start;
    padding: 24px 16px;
  }
  .custom-stepper ::v-deep .v-stepper__step {
    padding: 16px 0;
    width: 100%;
    justify-content: flex-start;
  }
  .custom-stepper ::v-deep .v-stepper__label {
    display: block !important;
    text-align: left;
    margin-left: 12px;
  }
  .custom-stepper ::v-deep .v-divider {
    display: none;
  }
}
</style>